import React from 'react';
import { Typography, Card, Switch, Space, Divider } from 'antd';
import { BulbOutlined, BulbFilled } from '@ant-design/icons';
import { useTheme } from '../context/ThemeContext';

const { Title, Text } = Typography;

export default function Settings() {
  const { isDark, setIsDark } = useTheme();

  return (
    <Space direction="vertical" size="large" style={{ width: '100%', maxWidth: 600 }}>
      <div>
        <Title level={4} style={{ margin: 0 }}>Settings</Title>
        <Text type="secondary">Customize your experience</Text>
      </div>

      <Card title="Display">
        <Space direction="vertical" style={{ width: '100%' }} size="middle">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Space>
              {isDark ? <BulbFilled style={{ fontSize: 18 }} /> : <BulbOutlined style={{ fontSize: 18 }} />}
              <div>
                <Text strong>Dark Mode</Text>
                <br />
                <Text type="secondary" style={{ fontSize: 12 }}>
                  Switch between light and dark interface
                </Text>
              </div>
            </Space>
            <Switch
              checked={isDark}
              onChange={setIsDark}
              checkedChildren="Dark"
              unCheckedChildren="Light"
            />
          </div>
          <Divider style={{ margin: 0 }} />
          <Text type="secondary" style={{ fontSize: 12 }}>
            Your preference is saved locally in your browser.
          </Text>
        </Space>
      </Card>
    </Space>
  );
}
